import { wrap } from "../_"

export default (a: NuxtAxiosInstance) => ({
  submitFeedback: (model: Record<string, string>) =>
    wrap(a.$post("/media/feedback", model)),
})
